import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://little-feet-server.vercel.app/api';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  createAdmin: (data) => api.post('/auth/create-admin', data),
  register: (homeData) => api.post('/auth/register', homeData),
  getCurrentHome: () => api.get('/auth/me'),
  getHomes: () => api.get('/auth/homes'),
  updateHome: (id, data) => api.put(`/auth/homes/${id}`, data),
  deleteHome: (id) => api.delete(`/auth/homes/${id}`),
};

// Visitor Logs API
export const visitorLogAPI = {
  submitLog: (logData) => axios.post(`${API_URL}/visitor-logs`, logData),
  getHomeDetails: (homeId) => axios.get(`${API_URL}/visitor-logs/home/${homeId}`),
  getLogs: () => api.get('/visitor-logs'),
  getStats: () => api.get('/visitor-logs/stats'),
  getAllLogs: () => api.get('/visitor-logs/all'),
  getAllStats: () => api.get('/visitor-logs/stats/all'),
  deleteLog: (id) => api.delete(`/visitor-logs/${id}`),
  resolveLog: (id, data) => api.put(`/visitor-logs/${id}/resolve`, data),
  exportLogs: () => api.get('/visitor-logs/export'),
};

// Resident Feedback API
export const feedbackAPI = {
  submitFeedback: (feedbackData) => axios.post(`${API_URL}/resident-feedback`, feedbackData),
  getFeedbacks: () => api.get('/resident-feedback'),
  getStats: () => api.get('/resident-feedback/stats'),
  getAllFeedbacks: () => api.get('/resident-feedback/all'),
  getAllStats: () => api.get('/resident-feedback/stats/all'),
  updateFeedback: (id, data) => api.put(`/resident-feedback/${id}`, data),
  deleteFeedback: (id) => api.delete(`/resident-feedback/${id}`),
};

// Staff Feedback API
export const staffFeedbackAPI = {
  deleteStaffFeedback: (id) => api.delete(`/staff-feedback/${id}`),
};

export default api;
